import { OTHER_COMPETITOR_ID } from 'partner360/features/competitorsSob/constants'
import { ISobCompetitorsDependOnSettings } from 'partner360/models/ISobCompetitorsDependOnSettings'

export const getOtherCompetitorSob =
  (items: ISobCompetitorsDependOnSettings[]) => (field: keyof ISobCompetitorsDependOnSettings) => {
    const otherItem = items.find((el) => el.CompetitorID === OTHER_COMPETITOR_ID)
    if (!otherItem) return 0

    const otherValue = otherItem[field] as number
    if (!otherValue) return 0

    const hasNotEmptyValues = items.some(
      (el) => el.CompetitorID !== OTHER_COMPETITOR_ID && el[field]
    )
    return hasNotEmptyValues ? otherValue : 0
  }
